import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import { combineReducers } from 'redux';

import appPushNotifications from './components/appPushNotification/Reducer';
import errorBoundaryReducer from './components/errorBoundary/Reducer';
import errorHandlerReducer from './components/errorHandler/Reducer';
import addImageModalReducer from './components/modals/addImage/Reducer';
import addListsModalReducer from './components/modals/addListModal/Reducer';
import chooseProfileImageModalReducer from './components/modals/chooseProfileImageModal/Reducer';
import confirmationReducer from './components/modals/confirmation/Reducer';
import answerModalReducer from './components/modals/createAnswer/Reducer';
import createFolderReducer from './components/modals/createFolder/Reducer';
import questionModalReducer from './components/modals/createQuestion/Reducer';
import studySongModalReducer from './components/modals/studySong/Reducer';
import quizDetailsReducer from './pagesNext/quizDetails/Reducer';
import imagePreviewReducer from './components/modals/imagePreview/Reducer';
import onboardingModalReducer from './components/modals/onboarding/Reducer';
import parentRequestModalReducer from './components/modals/parentRequest/Reducer';
import payInvoiceModalReducer from './components/modals/payInvoice/Reducer';
import reportModalReducer from './components/modals/reportModal/Reducer';
import switchPackageModalReducer from './components/modals/switchPackage/Reducer';
import manageQuizModalReducer from './components/modals/manageQuizModal/Reducer';
import notificationReducer from './components/notification/Reducer';
import notificationsReducer from './components/notifications/Reducer';
import playButtonReducer from './components/playButton/Reducer';
import sidebarReducer from './components/sideBar/Reducer';
import activationCodeReducer from './pages/activation/Reducer';
import reducer from './pages/bookDetails/Reducer';
import couponReducer from './pages/couponReader/Reducer';
import createListReducer from './pages/createList/Reducer';
import exerciseReducer from './pages/exercises/Reducer';
import folderDetailsReducer from './pages/folderDetails/Reducer';
import forgotPasswordReducer from './pages/forgotPassword/Reducer';
import groupDetailsReducer from './pages/groupDetails/Reducer';
import groupOverviewReducer from './pages/groupOverview/Reducer';
import languageSelectorReducer from './components/languageSelector/Reducer';
import listDetailsReducer from './pages/listDetails/Reducer';
import listsReducer from './pages/lists/Reducer';
import methodReducer from './pages/methodDetails/Reducer';
import packagesReducer from './pages/packages/Reducer';
import parentShopReducer from './pages/publicShop/Reducer';
import paymentDetailsReducer from './pages/successPayment/Reducer';
import profileSettingsReducer from './pages/profileSettings/Reducer';
import publicProfileReducer from './pages/publicProfile/Reducer';
import resetPasswordReducer from './pages/resetPassword/Reducer';
import resultDetailsReducer from './pages/resultDetails/Reducer';
import searchReducer from './pages/search/Reducer';
import searchDetailsReducer from './pages/searchDetails/Reducer';
import shopReducer from './pages/shop/Reducer';
import signInReducer from './pages/signIn/Reducer';
import signUpReducer from './pages/signUp/Reducer';
import chapterDetailsReducer from './pagesNext/chapterDetails/Reducer';
import exerciseNextReducer from './pagesNext/exercise/Reducer';
import qaReducer from './pagesNext/qA/Reducer';
import selectBookReducer from './pagesNext/selectBook/Reducer';
import sharedReducer from './pagesNext/shared/Reducer';
import subjectDetailsReducer from './pagesNext/subjecDetails/Reducer';
import testResultsReducer from './pagesNext/testResults/Reducer';
import topicDetailsReducer from './pagesNext/topicDetails/Reducer';
import resultTabReducer from './pagesNext/resultTab/Reducer';
import quizEditorReducer from './components/quiz/Reducer';
import liveBattleReducer from './pagesNext/live/Reducer';
import examDetailsReducer from './pagesNext/examDetails/Reducer';
import offerReducer from './pages/offer/Reducer';
import packageCancellationReducer from './components/packageCancellation/Reducer';
import streaksBarReducer from './components/streaksBar/Reducer';
import streaksModalReducer from './components/modals/streaks/Reducer';
import achievementsModalReducer from './components/modals/achievements/Reducer';
import tutoringSharedReducer from './tutoring/shared/Reducer';
import studySongReducer from './pages/studySong/Reducer';
import liveLessonModalReducer from './components/modals/liveLesson/Reducer';
import lessonReducer from './tutoring/pages/lesson/Reducer';
import resultsModalReducer from './components/modals/results/Reducer';
import lessonOverviewReducer from './tutoring/pages/lessonOverview/Reducer';
import lessonDetailsReducer from './tutoring/pages/lessonDetails/Reducer';
import lessonRequestModalReducer from './components/modals/lessonRequest/Reducer';
import addGroupManagersModalReducer from './pages/groupDetails/modals/addManager/Reducer';
import selectOwnerModalReducer from './pages/groupDetails/modals/selectOwner/Reducer';
import npsModalReducer from './components/modals/nps/Reducer';
import reverseTrialModalReducer from './components/modals/reverseTrial/Reducer';
import addWysiwygImageModalReducer from './components/wysiwyg/addImage/Reducer';
import addWysiwygAnswerModalReducer from './components/wysiwyg/addAnswer/Reducer';
import addWysiwygFormulaModalReducer from './components/wysiwyg/addFormula/Reducer';
import addWysiwygVideoModalReducer from './components/wysiwyg/addVideo/Reducer';
import addWysiwygAudioModalReducer from './components/wysiwyg/addAudio/Reducer';
import licenseInviteLinkModalReducer from './components/modals/licenseInviteLinkModal/Reducer';
import learningPathReducer from './components/learningPath/Reducer';
import shareModalReducer from './components/modals/share/Reducer';
import aiChatReducer from './components/modals/chat/Reducer';
import renewalSubscriptionModalReducer from './components/modals/renewalSubscription/Reducer';

const rootReducer = (history) =>
	combineReducers({
		router: connectRouter(history),
		form: formReducer,
		activationCodeReducer,
		addImageModalReducer,
		addListsModalReducer,
		quizEditorReducer,
		answerModalReducer,
		appPushNotifications,
		bookDetailsReducer: reducer,
		chapterDetailsReducer,
		chooseProfileImageModalReducer,
		confirmationReducer,
		couponReducer,
		createFolderReducer,
		createListReducer,
		errorBoundaryReducer,
		errorHandlerReducer,
		exerciseNextReducer,
		exerciseReducer,
		folderDetailsReducer,
		forgotPasswordReducer,
		groupDetailsReducer,
		groupOverviewReducer,
		imagePreviewReducer,
		languageSelectorReducer,
		listDetailsReducer,
		listsReducer,
		liveBattleReducer,
		manageQuizModalReducer,
		methodReducer,
		notificationReducer,
		notificationsReducer,
		onboardingModalReducer,
		packagesReducer,
		packageCancellationReducer,
		parentRequestModalReducer,
		parentShopReducer,
		payInvoiceModalReducer,
		paymentDetailsReducer,
		playButtonReducer,
		profileSettingsReducer,
		publicProfileReducer,
		qaReducer,
		questionModalReducer,
		quizDetailsReducer,
		reportModalReducer,
		resetPasswordReducer,
		resultDetailsReducer,
		resultTabReducer,
		searchDetailsReducer,
		searchReducer,
		selectBookReducer,
		sharedReducer,
		shopReducer,
		sidebarReducer,
		signInReducer,
		signUpReducer,
		studySongModalReducer,
		subjectDetailsReducer,
		switchPackageModalReducer,
		testResultsReducer,
		topicDetailsReducer,
		examDetailsReducer,
		offerReducer,
		streaksBarReducer,
		streaksModalReducer,
		achievementsModalReducer,
		tutoringSharedReducer,
		studySongReducer,
		liveLessonModalReducer,
		lessonReducer,
		resultsModalReducer,
		lessonOverviewReducer,
		lessonDetailsReducer,
		lessonRequestModalReducer,
		addGroupManagersModalReducer,
		selectOwnerModalReducer,
		npsModalReducer,
		reverseTrialModalReducer,
		addWysiwygImageModalReducer,
		addWysiwygAnswerModalReducer,
		addWysiwygFormulaModalReducer,
		addWysiwygVideoModalReducer,
		addWysiwygAudioModalReducer,
		licenseInviteLinkModalReducer,
		learningPathReducer,
		shareModalReducer,
		aiChatReducer,
		renewalSubscriptionModalReducer,
	});

export default rootReducer;
